import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
const initialState = {
  data: null,
  loading: false,
  error: null,
};

const authRedeemSlice = createSlice({
  name: "gamehistory",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },
  },
});

// Actions
export const { requestStart, ApiSuccess, requestFailure,  } =
  authRedeemSlice.actions;

export const GamehistorySlice = (data) => async (dispatch) => {
  try {
    dispatch(requestStart());
    const response = await axios.get(`/private/history`);
    dispatch(ApiSuccess(response.data));
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "Login failed!"
    );
    dispatch(
      requestFailure(err?.response?.data?.message || "Something went wrong!")
    );
  }
};

export default authRedeemSlice.reducer;
